import React, { useState } from 'react';
import { Outlet, Link } from 'react-router-dom';
import menu from "./menu.png"
import close from "./close.png"

const Navbar = () => {
    
    const [isOpen, setIsOpen] = useState(false);
   
    const itemClick = () => {
        setIsOpen(false);
  }

    return (
        <>
            <header>
                <div id="myNav" >
                    <div className="relative p-4 pt-5 justify-between lg:pt-7 lg:pb-7 flex items-center lg:justify-around lg:gap-20">
                        <div className="lg:pr-52 ">
                            <Link to={"/"}> <h2 className='text-4xl lg:text-4xl cursor-pointer '>DK</h2> </Link>
                        </div>
                        <div className=" pl-52 ">
                        <button id="toggle" className=" right-4 top-4 cursor-pointer  " onClick={() => setIsOpen(!isOpen)}  >
                            <img className='h-9' src={menu} alt='menu' />
                        </button>
                    </div> 
                    <div className=  {` h-full  w-full  bg-white fixed top-0 left-0  ${ !isOpen ? "hidden" : "block"}`}> 
                    <div className=' lg:pt-7 pt-4 pr-4 flex justify-end  lg:pr-52  '>
                    <button id="toggle" className="cursor-pointer " onClick={() => setIsOpen(!isOpen)} >
                            <img className='h-10' src={close} alt='menu' />
                        </button>
                        </div>
                    <div className='text-4xl h-3/4 grid justify-items-center content-center gap-8  '>
                    <Link to={"/about"} className="  sm:border-0 md:relative md:after:bg-red-700 md:after:absolute md:after:h-1 md:after:w-0 md:after:bottom-0 md:after:left-0 md:hover:after:w-full md:after:transition-all md:after:duration-300 cursor-pointer" onClick={itemClick}>About</Link>
                    <Link to={"/projects"} className=" sm:border-0 md:relative md:after:bg-red-700 md:after:absolute md:after:h-1 md:after:w-0 md:after:bottom-0 md:after:left-0 md:hover:after:w-full md:after:transition-all md:after:duration-300 cursor-pointer" onClick={itemClick}>Projects</Link>
                    <Link to={"/contact"} className=" sm:border-0 md:relative md:after:bg-red-700 md:after:absolute md:after:h-1 md:after:w-0 md:after:bottom-0 md:after:left-0 md:hover:after:w-full md:after:transition-all md:after:duration-300 cursor-pointer" onClick={itemClick}>Contact</Link>
                    </div>
                    </div>
                    </div>
                </div>
            </header>
            <Outlet />
        </>
    );
}

export default Navbar;